import React from 'react'
import './Footer.css'
import Images from '../assets/images'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Facebook, Instagram, LinkedIn } from '@mui/icons-material'

const Footer = () => {
  const { t } = useTranslation()

  const links = t('footer.links', { returnObjects: true }) || []
  const legal = t('footer.legal', { returnObjects: true }) || []

  const scrollToSection = (target) => {
    if (!target) {
      return
    }

    const elementById = document.getElementById(target)
    const elementByClass = document.querySelector(`.${target}`)
    const element = elementById || elementByClass

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  const openExternalLink = (url) => {
    if (!url || url === '#') {
      return
    }

    window.open(url, '_blank', 'noopener,noreferrer')
  }

  return (
    <footer className='footer'>
      <div className='footerContent'>
        <div className='brandColumn'>
          <img
            alt='tiim'
            className='logoWhite'
            src={Images.tiim.logo}
          />
        </div>

        <div className='menuColumn desktop'>
          <h4>{t('footer.linksTitle')}</h4>
          <ul>
            {links.map((item, index) => (
              <li key={index}>
                {item.path
                  ? <Link to={item.path}>{item.label}</Link>
                  : (
                    <button type='button' onClick={() => scrollToSection(item.target)}>
                      {item.label}
                    </button>
                  )}
              </li>
            ))}
          </ul>
        </div>

        <div className='menuColumn legalColumn'>
          <h4>{t('footer.legalTitle')}</h4>
          <ul>
            {legal.map((item, index) => (
              <li key={index}>
                <Link to={item.path}>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className='socialColumn'>
          <h4 className='desktop'>{t('footer.socialTitle')}</h4>
          <div className='socialList'>
            <button type='button' aria-label='instagram' onClick={() => openExternalLink(t('footer.instagram'))}>
              <Instagram />
            </button>
            <button type='button' aria-label='facebook' onClick={() => openExternalLink(t('footer.facebook'))}>
              <Facebook />
            </button>
            <button type='button' aria-label='linkedin' onClick={() => openExternalLink(t('footer.linkedin'))}>
              <LinkedIn />
            </button>
          </div>
        </div>
      </div>

      <div className='copyright'>
        <p>{t('footer.copyright')}</p>
      </div>

    </footer>
  )
}

export default Footer